import { AppState } from '../store';

export function getPlatform(state: AppState) {
  return state.platform;
}
